import preferenceSlice from "./preference/preferenceSlice";
const rootReducer = {
  preference: preferenceSlice,
};

export default rootReducer;
